
export const BlastSampleUrl = 'https://tbd.im/xxxxxxxxxxxxxxxxx';
// export const BlastSampleUrl = 'https://tbds.vip/xxxxxxxxxxxxxxxxx';
export const StdBlastTemplateTypeList: string[] = [
    'qrcode',
    'reminder',
    'thank_you',
];
